"use strict";

Object.defineProperty(exports, Symbol.toStringTag, {
  value: "Module"
});

var t = require("react");

var i = (e => (e.Mouse = "mouse", e.Touch = "touch", e.Pointer = "pointer", e))(i || {}),
    h = (e => (e.CancelledByMovement = "cancelled-by-movement", e.CancelledByRelease = "cancelled-by-release", e))(h || {});

function b(e) {
  var n = e.nativeEvent;
  return n ? window.TouchEvent && n instanceof TouchEvent || "touches" in n : !1;
}

function B(e) {
  return e.nativeEvent instanceof MouseEvent && !(e.nativeEvent instanceof PointerEvent);
}

function D(e) {
  var n = e.nativeEvent;
  return n ? window.PointerEvent && n instanceof PointerEvent || "pointerId" in n : !1;
}

function C(e) {
  return B(e) || b(e) || D(e);
}

function L(e) {
  return b(e) ? {
    x: e.touches[0].pageX,
    y: e.touches[0].pageY
  } : B(e) || D(e) ? {
    x: e.pageX,
    y: e.pageY
  } : null;
}

function S(e) {
  return {
    target: e.target,
    currentTarget: e.currentTarget,
    nativeEvent: e,
    persist: () => {}
  };
}

function A(e) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$threshold = _ref.threshold,
      n = _ref$threshold === void 0 ? 400 : _ref$threshold,
      _ref$captureEvent = _ref.captureEvent,
      l = _ref$captureEvent === void 0 ? !1 : _ref$captureEvent,
      _ref$detect = _ref.detect,
      m = _ref$detect === void 0 ? i.Pointer : _ref$detect,
      _ref$cancelOnMovement = _ref.cancelOnMovement,
      d = _ref$cancelOnMovement === void 0 ? !1 : _ref$cancelOnMovement,
      v = _ref.filterEvents,
      T = _ref.onStart,
      y = _ref.onMove,
      x = _ref.onFinish,
      M = _ref.onCancel;

  var g = t.useRef(!1),
      c = t.useRef(!1),
      s = t.useRef(),
      a = t.useRef(),
      p = t.useRef(e),
      f = t.useRef(null),
      E = t.useCallback(r => {
    c.current || C(r) && (v !== void 0 && !v(r) || (l && r.persist(), T !== null && T !== void 0 && T(r, {
      context: s.current
    }), f.current = L(r), c.current = !0, a.current = setTimeout(() => {
      p.current && (p.current(r, {
        context: s.current
      }), g.current = !0);
    }, n)));
  }, [l, v, T, n]),
      o = t.useCallback((r, u) => {
    C(r) && c.current && (f.current = null, l && r.persist(), g.current ? x === null || x === void 0 ? void 0 : x(r, {
      context: s.current
    }) : c.current && (M === null || M === void 0 ? void 0 : M(r, {
      context: s.current,
      reason: u !== null && u !== void 0 ? u : h.CancelledByRelease
    })), g.current = !1, c.current = !1, a.current !== void 0 && clearTimeout(a.current));
  }, [l, x, M]),
      w = t.useCallback(r => {
    if (y !== null && y !== void 0 && y(r, {
      context: s.current
    }), d && f.current) {
      var u = L(r);

      if (u) {
        var P = d === !0 ? 25 : d,
            R = {
          x: Math.abs(u.x - f.current.x),
          y: Math.abs(u.y - f.current.y)
        };
        (R.x > P || R.y > P) && o(r, h.CancelledByMovement);
      }
    }
  }, [o, d, y]);
  return t.useEffect(() => {
    function r(u) {
      var P = S(u);
      o(P);
    }

    return window.addEventListener("mouseup", r), window.addEventListener("touchend", r), window.addEventListener("pointerup", r), () => {
      window.removeEventListener("mouseup", r), window.removeEventListener("touchend", r), window.removeEventListener("pointerup", r);
    };
  }, [o]), t.useEffect(() => () => {
    a.current !== void 0 && clearTimeout(a.current);
  }, []), t.useEffect(() => {
    p.current = e;
  }, [e]), t.useCallback(r => {
    if (s.current = r, e === null) return {};

    switch (m) {
      case i.Mouse:
        return {
          onMouseDown: E,
          onMouseMove: w,
          onMouseUp: o
        };

      case i.Touch:
        return {
          onTouchStart: E,
          onTouchMove: w,
          onTouchEnd: o
        };

      case i.Pointer:
        return {
          onPointerDown: E,
          onPointerMove: w,
          onPointerUp: o
        };
    }
  }, [e, o, m, w, E]);
}

exports.LongPressCallbackReason = h;
exports.LongPressEventType = i;
exports.useLongPress = A;